import IconDefault from '@assets/icons/default.svg?react';
import IconDelete from '@assets/icons/delete.svg?react';
import IconDuplicate from '@assets/icons/duplicate.svg?react';
import IconPlus from '@assets/icons/plus.svg?react';
import IconSave from '@assets/icons/save.svg?react';
import IconWarningExclamation from '@assets/icons/warning-exclamation.svg?react';
import {
 Box,
 Checkbox,
 FormControlLabel,
 FormGroup,
 IconButton,
 Menu,
 MenuItem,
 Theme,
 Typography,
 useMediaQuery,
} from '@mui/material';
import { FormControl, InputLabel, Select } from '@mui/material';
import themeOptions from '../../../utils/theme';
import useModalConf from './useModalConf';

const ModalConf = () => {
 const {
  confName,
  th,
  t,
  currentPresets,
  currentPreset,
  wasChanged,
  addDisabled,
  isProChecked,
  handleCreate,
  handleDelete,
  handleDuplicate,
  handleProChange,
  handleSelectPreset,
  handleRevert,
  handleSave,
 } = useModalConf();

 const isLargerThanMd = useMediaQuery(themeOptions().breakpoints.up('md'));

 if (!isLargerThanMd) {
  return !currentPresets ? (
   <>...</>
  ) : (
   <Box sx={{ width: '100%', p: 3 }}>
    <Typography sx={{ fontSize: 18, fontWeight: 500, mb: '18px' }}>
     {confName === 'columns'
      ? t('colModal.colSettings')
      : t('filterModal.filterSettings')}
    </Typography>
    <FormControl sx={{ width: '100%' }}>
     <InputLabel htmlFor="presetSelect">Pasirinkite derinį</InputLabel>
     <Select
      id="presetSelect"
      onChange={(e: any) => {
       const preset = currentPresets?.find(
        (item) => item.name === e.target.value,
       );
       if (!preset) return;
       handleSelectPreset(preset);
      }}
      value={currentPreset?.name || ''}
      label="Pasirinkite derinį"
     >
      {currentPresets?.map((item) => (
       <MenuItem key={item.name} value={item.name}>
        {item.name}
       </MenuItem>
      ))}
     </Select>
    </FormControl>
   </Box>
  );
 }

 return (
  <Box
   sx={{
    p: 3,
    minWidth: 330,
    height: '100%',
    position: 'sticky',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
   }}
  >
   <Typography sx={{ fontSize: 18, fontWeight: 500, mb: '18px' }}>
    {confName === 'columns'
     ? t('colModal.colSettings')
     : t('filterModal.filterSettings')}
   </Typography>
   <Box
    sx={{
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'space-between',
     mb: '14px',
    }}
   >
    <Typography
     sx={{ fontSize: 14, fontWeight: 500, color: th.palette.kemek.darkGray }}
    >
     {confName === 'columns'
      ? t('colModal.colPresets')
      : t('filterModal.filterPresets')}
    </Typography>
    <IconButton
     aria-label="create"
     disabled={addDisabled}
     onClick={() => handleCreate()}
     sx={() => ({
      opacity: addDisabled ? 0.5 : 1,
     })}
    >
     <IconPlus style={{ color: th.palette.kemek.blue }} />
    </IconButton>
   </Box>
   <Box
    sx={{
     borderRadius: '4px',
     border: `1px solid ${th.palette.kemek.lightestGray}`,
     mb: '12px',
     overflow: 'hidden',
    }}
   >
    {currentPresets?.map((item) => (
     <Box
      key={item.name || 'no-name'}
      onClick={() => handleSelectPreset(item)}
      sx={(theme: Theme) => ({
       cursor: 'pointer',
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'space-between',
       gap: '4px',
       fontSize: 12,
       transition: 'background-color 0.3s ease-in-out',
       backgroundColor:
        item.name === currentPreset?.name
         ? theme.palette.mode === 'dark'
           ? theme.palette.kemek.lightBlue
           : theme.palette.kemek.bg1
         : 'transparent',
       p: '12px',
       borderBottom: `1px solid ${theme.palette.kemek.lightestGray}`,
       '&:last-child': { borderBottom: 0 },
      })}
     >
      {item.name}{' '}
      {item.name === currentPreset?.name && wasChanged && (
       <IconWarningExclamation />
      )}
     </Box>
    ))}
   </Box>
   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
    <IconButton
     aria-label="delete"
     disabled={!currentPreset}
     onClick={handleDelete}
     sx={() => ({
      opacity: !currentPreset ? 0.5 : 1,
      color: (theme: Theme) =>
       theme.palette.mode === 'dark'
        ? theme.palette.kemek.lightRed
        : theme.palette.kemek.red,
     })}
    >
     <IconDelete
     // style={{ color: th.palette.kemek[!currentPreset ? 'gray' : 'red'] }}
     />
    </IconButton>
    <IconButton
     aria-label="duplicate"
     disabled={!currentPreset}
     onClick={() => handleDuplicate()}
     sx={() => ({
      opacity: !currentPreset ? 0.5 : 1,
     })}
    >
     <IconDuplicate
      style={{
       color: th.palette.kemek[!currentPreset ? 'gray' : 'darkestGray'],
      }}
     />
    </IconButton>
    <IconButton
     disabled={!currentPreset || !wasChanged}
     aria-label="revert"
     onClick={handleRevert}
     sx={() => ({
      ml: 'auto',
      opacity: !currentPreset || !wasChanged ? 0.5 : 1,
     })}
    >
     <IconDefault
      style={{
       color:
        th.palette.kemek[
         !currentPreset || !wasChanged ? 'gray' : 'darkestGray'
        ],
      }}
     />
    </IconButton>
    <IconButton
     disabled={!currentPreset || !wasChanged}
     aria-label="save"
     id="col-save-button"
     onClick={handleSave}
     sx={() => ({
      opacity: !wasChanged ? 0.5 : 1,
     })}
    >
     <IconSave
      style={{
       color: th.palette.kemek[!wasChanged ? 'gray' : 'blue'],
      }}
     />
    </IconButton>
   </Box>
   {confName === 'columns' && (
    <Box sx={{ mt: 'auto' }}>
     <FormGroup>
      <FormControlLabel
       control={
        <Checkbox checked={isProChecked} onChange={() => handleProChange()} />
       }
       label={t('colModal.compactVersion')}
      />
     </FormGroup>
    </Box>
   )}
  </Box>
 );
};
export default ModalConf;
